import { Component, Input, OnInit } from "@angular/core";
import { ViewWillEnter } from "@ionic/angular";
import { ActivatedRoute, Route, Router } from "@angular/router";
import { RouteDeliveryDetailsService } from "../../../../services/route-delivery-details.service";
import { GRouteService } from "../../../../services/g-route.service";
import { RouteModel } from "../../../../models/route.model";
import { GtrakAuthService } from "../../../../../../../app/features/authentication/services/gtrak-auth.service";
import { te } from "date-fns/locale";
import {
  RouteDeliveryDetailsFreq,
  RouteDeliveryDetailsPickup,
} from "../../../../models/route-delivery-details.model";
import { CustomerProductsScheduleService } from "../../../../services/customer-products-schedule.service";
import { CustomerProductsSchedule } from "../../../../models/customer-products-schedule.model";
import { ToasterService } from "../../../../../../../app/common/services/toaster.service";
import { DateTime } from "luxon";
import {CommonService} from "../../../../../../../app/common/services/common.service"
@Component({
  selector: "app-non-garments-page",
  templateUrl: "non-garments.page.html",
  styleUrls: [
    "./non-garments.page.scss",
    "../../../../styles/g-route.styles.scss",
  ],
})
export class NonGarmentsPage implements ViewWillEnter, OnInit {
  currentRoute: RouteModel;
  stopName: string;
  deliveryList: RouteDeliveryDetailsFreq[] = [];
  productsServiceList: RouteDeliveryDetailsPickup[] = [];
  offWeekProducts: CustomerProductsSchedule[] = [];
  frequencyDate: number;
  customerCode: string;
  currentWeek: number = 0;
  currentDay:number=0
  productsWarningFlag: boolean = false;
   loader:boolean=false;
  routeStopName: string = "";
  forDateStr:string="";
  loaded: boolean = false;
  breadcrumbs=[];
  processingRequest: boolean = false;
  estRouteDate:Date;
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private routeDeliveryDetailsService: RouteDeliveryDetailsService,
    private productsScheduleService: CustomerProductsScheduleService,
    private toasterService: ToasterService,
    private gRouteService: GRouteService,
    private authService: GtrakAuthService,
    private commonService:CommonService,
    
  ) {
    this.currentRoute = null;
  }

  async ngOnInit() {
    this.loader = false;
    this.routeStopName = localStorage.getItem('routeStopName');
    //get date difference from route date and 1/3/2000
    //this will be used to determine the current week
    var date1=new Date("12/27/1999");
    const date2 = new Date(this.authService.user.routeDate);
    // const date1 = new Date("1/3/2000");
    // const date2 = new Date(this.authService.user.routeDate);
    const diffTime = Math.abs(date2.getTime() - date1.getTime());
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    this.currentWeek = diffDays % 28;
    this.currentWeek = Math.floor(this.currentWeek / 7) + 1;

    this.stopName = this.route.snapshot.paramMap.get("id");
    this.breadcrumbs.push({ label: 'Home', url: '/route' });
    this.breadcrumbs.push({ label: 'Logsheet', url: '/route/logsheet' });
    this.breadcrumbs.push({ label: 'Stop', url: '/route/logsheet/stop/'+ this.stopName });

    this.currentRoute = await this.gRouteService.get(this.authService.user.routeCode);
    this.frequencyDate = this.currentRoute.frequencyOffset(this.authService.user.routeDate);
    this.currentDay=this.currentRoute.getDay(this.authService.user.routeDate);
      this.forDateStr= this.commonService.getDateOnly(this.authService.user.routeDate);
  

    this.getDeliveryDetailsAndProducts();
   await   this.getPickupList();
    window.dispatchEvent(new Event("resize"));

    this.loaded = true;
    this.loader = true;
  }
 async getPickupList():Promise<void>{
  this.loader=false;
    const promises = [];
    await promises.push(this.routeDeliveryDetailsService.GetPickupList(
      this.stopName,
      this.authService.user.routeCode,
      this.forDateStr,
      this.frequencyDate
    ));
    const promiseData = await Promise.all(promises);
    const pickupList = promiseData[0];
    this.processPickupList(pickupList);
     this.loader=true;
}
  

  processPickupList(response: any): void {
    this.productsServiceList = response ?? [];
    for (const obj of response ?? []) {
      if (isNaN(Number(obj.qtyAsString))) {
        this.productsWarningFlag = true;
        break;
      }
    }
  }

  processOffweekData(response: any): void {
    (response ?? []).forEach((element) => {
      element.frequency = this.weekVal(element.frequency);
      //check if week number is the same as current week or if the trimmed week is ""... if so, then remove it from the list
      if (
        element.frequency === this.currentWeek.toString() ||
        element.frequency.trim() === ""
      ) {
        response.splice(response.indexOf(element), 1);
      }
    });
    this.offWeekProducts = response;
  }

  processDeliveryList(response: any): void {
    //if response is empty or if not an array, then return an empty array of routeDeliveryDetailfreq
    if (response.length === 0 || !Array.isArray(response)) {
      //set response type to customerProductsSchedule
      const customerProductsSchedule: CustomerProductsSchedule =
        response as unknown as CustomerProductsSchedule;
      this.customerCode = customerProductsSchedule.customerCode;
      return;
    }
    //in reverse order remove duplicate items with the same sequence number
    let temp = response.reverse();
    let seen = {};
    let out: RouteDeliveryDetailsFreq[] = [];
    temp.forEach((element) => {
      if (!seen[element.routeDeliveryDetail.seqNumber]) {
        seen[element.routeDeliveryDetail.seqNumber] = true;
 
        let frequency = element.frequency;
        let weeks = "";
        for (let i = 0; i < 4; i++) {
          let tmp = frequency.substr(i * 7, 7);
          if (parseInt(tmp, 10) > 0) {
            weeks += (i + 1).toString();
          }
        }
        element.routeDeliveryDetail.week = parseInt(weeks);

        out.push(element);
      }
    });
    //no go through that list and make product quota half if the product category isnt MAT
    out.forEach((element) => {
      element.routeDeliveryDetail.productQuotaHalf =element.routeDeliveryDetail.productQuota / 2;
      if (element.routeDeliveryDetail.productCategory.substring(0, 3).toUpperCase() === 'MAT' ){
        element.routeDeliveryDetail.productQuotaHalf =element.routeDeliveryDetail.productQuota;
      }
      if( element.routeDeliveryDetail.productLastUsedQty==null){
        element.routeDeliveryDetail.productLastUsedQty=0;
      }
      if (element.routeDeliveryDetail.productCategory.substring(0, 3).toUpperCase() === 'MAT' && element.routeDeliveryDetail.productLastUsedQty === 0) {
        element.routeDeliveryDetail.productLastUsedQty  = element.routeDeliveryDetail.productQuota / 2;
      }
    });

    //get customer code from first element
    this.customerCode = out[0].routeDeliveryDetail.customerCode;

    this.deliveryList = out;
  }

  ionViewWillEnter(): void {}

  async saveProducts() :Promise<void>{
    this.loader=false;
    this.processingRequest = true;
    this.productsServiceList.forEach(p => {
      p.login = this.authService.user.id as string;
    });

    const forDateString= this.commonService.getDateOnly(this.authService.user.routeDate);
      await  this.routeDeliveryDetailsService
          .UpdatePickupList(this.productsServiceList,forDateString)
          .then((response) => {
            if (response === "Saved") {
               this.getPickupList();
              this.toasterService.presentToast(
                "primary",
                "",
                "Products Saved",
                1000
              );
            } else {
              this.toasterService.presentToast(
                "danger",
                "",
                "An error occurred",
                1000
              );
            }
          }).finally(() => {
            this.processingRequest = false;
          });
        this.loader=true;
  }

  async  getDeliveryDetailsAndProducts(){
    try {
       const forDateString= this.commonService.getDateOnly(this.authService.user.routeDate);
      const deliveryList = await this.routeDeliveryDetailsService.GetDeliveryList(
        this.stopName,
        this.authService.user.routeCode,
       forDateString,
      );
      var customerCode=""
      if(deliveryList.length>0){
        customerCode= deliveryList[0].routeDeliveryDetail.customerCode;
      }
       const forDateStr= this.commonService.getDateOnly(this.authService.user.routeDate);
      const offWeekProducts = await this.productsScheduleService.GetOffWeekProducts(
        this.stopName,
        customerCode,  
        forDateStr
      );
  
    this.processDeliveryList(deliveryList);
    this.processOffweekData(offWeekProducts);
    } catch (error) {
      console.error("Error in fetching delivery details or off-week products", error);
      throw error;
    }
  }
  
  weekVal(frequency: string): string {
    let res = "";
    if (!frequency) return "";

    for (let i = 0; i < 4; i++) {
      const tmp = frequency.substr(i * 7, 7);
      if (parseInt(tmp, 10) > 0) {
        res += (i + 1).toString();
      }
    }
    return res;
  }

  editQuantity(event, row) {
    row.qty = event.target.value;
  }
}
